import { Text, Button, H0 } from '@components';
import styles from './ErrorFallback.module.scss';
import { BUTTON_TYPES } from '@types';
import BrokenTruckImage from '@img/broken-truck.png';
import { isPreloadError } from '@utils';

export interface ErrorFallbackProps {
	error?: unknown;
}

export const ErrorFallback = (props: ErrorFallbackProps) => {
	const { error } = props;
	const isStaleBuild = isPreloadError(error);

	const handleBackClicked = () => {
		window.history.back();
	};

	const handleRefreshClicked = () => {
		window.location.reload();
	};

	return (
		<div className={styles.errorFallbackContainer}>
			<div className={styles.errorMessageSection}>
				{isStaleBuild ?
					<>
						<H0>A new version of Ofload is available</H0>
						<Text>Refresh to load the latest version and continue.</Text>
					</> :
					<>
						<H0>Oops something went wrong</H0>
						<Text>There was a problem processing your request. Please try again.</Text>
					</>
				}
			</div>
			<img alt={'Broken truck'} src={BrokenTruckImage} />
			{isStaleBuild ?
				<Button onClick={handleRefreshClicked} text='Refresh' /> :
				<Button onClick={handleBackClicked} type={BUTTON_TYPES.SECONDARY} text='Return to last page' />
			}
		</div>
	);
}